module.exports = __webpack_public_path__ + "img/ai.afc0f250.png";